/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import * as X from "@/ui";

import CheckImage from "@/assets/shared-advantage-check.svg";
import SupportDesktopImage from "@/assets/bucket/retailer-home-support-desktop.png";
import SupportMobileImage from "@/assets/bucket/retailer-home-support-mobile.png";

import PersonImage from "@/assets/retailer-home-boost-person.png";
import GrowthImage from "@/assets/retailer-home-boost-growth.svg";
import CountriesImage from "@/assets/retailer-home-boost-countries.svg";
import { useRetailerHomePage } from "@/providers/strapi/content/types/singleTypes/retailer-home-page";
import ReactMarkdown from "react-markdown";


// const data = {
//   support: {
//     title: {
//       en: <>A service designed with <strong>your customers in mind</strong></>,
//       fr: <>Un service pensé <strong>pour votre client</strong></>,
//       zh: <>Un service pensé <strong>pour votre client</strong></>,
//     },
//     text1: {
//       en: "VAT refunds made easy, without lifting a finger. Your customer enters their info in the Zapptax app, and we handle the rest.",
//       fr: "Vous facilitez la détaxe, sans effort. Votre client saisit ses informations dans l’app Zapptax, nous nous occupons du reste.",
//       zh: ""
//     },
//     role: {
//       en: "Your role?",
//       fr: "Votre rôle ?",
//       zh: ""
//     },
//     text2: {
//       en: "Just issue an invoice to Zapptax. That’s it.",
//       fr: "Émettre une facture au nom de Zapptax… et c’est tout !",
//       zh: ""
//     },
//     bullet: {
//       en: "Less friction, better shopping experience.",
//       fr: "Moins de friction, un parcours d’achat optimisé",
//       zh: ""
//     },
//   },

//   boost: {
//     title: {
//       en: <>Boost sales, <strong>attract more customers.</strong></>,
//       fr: <>Boostez vos ventes, <strong>attirez plus de clients</strong></>,
//       zh: ""
//     },
//     text: [
//       {
//         en: `Tax-free shopping is a powerful way to win over international shoppers and drive more sales.`,
//         fr: `La détaxe digitale, un atout pour séduire une clientèle internationale et dynamiser vos ventes.`,
//         zh: ""
//       },
//       {
//         en: `Your customers save on VAT — and naturally buy more.`,
//         fr: `Vos clients intègrent naturellement une économie de TVA… et achètent plus.`,
//         zh: ""
//       },
//     ],
//     bullets: [
//       {
//         en: `More simplicity. More transactions.`,
//         fr: `Plus de simplicité, plus de transactions`,
//         zh: ""
//       },
//       {
//         en: `Free in-store materials to boost visibility.`,
//         fr: `Du matériel de communication à disposition pour plus de visibilité`,
//         zh: ""
//       },
//     ],
//     cta: {
//       en: `Become a partner`,
//       fr: `Devenir partenaire`,
//       zh: ""
//     },
//   },
// };


export function AdvantagesSection(_props: X.PageProps) {
  return (
    <section id="why" className="scroll-mt-[120px] mt-10 xl:my-20">
      <SupportMobile />
      <SupportDesktop />

      <BoostMobile />
      <BoostDesktop />
    </section>
  );
}


function SupportMobile() {
  // const tr = X.useTranslator();
  // const advantage = useRetailerHomePage('advantagesCard');
  const engagingCard = useRetailerHomePage('engagingCard');
  return (
    <div className={X.clsx(X.mobileOnly())}>
      <div className={X.clsx(
        "pl-mobile-margin mr-mobile-margin-half pr-mobile-margin-half",
        "bg-surface-blue py-8 xl:py-10 rounded-tr-4xl",
      )}>
        <FreedomCard />
      </div>
      <div className={X.clsx("mr-mobile-margin bg-surface-blue pl-mobile-margin-half")}>
        <div className={X.clsx("bg-white pl-mobile-margin-half rounded-tl-4xl py-10")}>

          {/* <h3 className="text-[36px] mb-6 leading-tight [&_strong]:font-medium">{tr(data.support.title)}</h3> */}
          <ReactMarkdown components={{
            p: ({ ...props }) => <h3 {...props} className="text-[36px] mb-6 leading-tight [&_strong]:font-medium" />
          }}>
            {engagingCard.title}
          </ReactMarkdown>

          <div className="flex flex-row gap-4 items-start mb-2">
            <p className=" flex-1 sm:flex-[70%] md:flex-[65%]  text-[16px] mb-6 leading-tight shrink-0">
              {/* {tr(data.support.text1)} */}
              {engagingCard.paragraph2}
            </p>
            {/* <X.Image src={SupportMobileImage} alt="Support" className="h-auto w-[47%]" /> */}
            <div className="w-[63px] sm:flex-[30%] md:flex-[35%] ">
              <X.Image src={engagingCard.image.url}
                width={engagingCard.image.width}
                height={engagingCard.image.height}
                alt="Support" className=" w-full h-auto rounded-md md:rounded-2xl"
                unoptimized />
            </div>
          </div>

          {/* <h4 className="text-[20px] font-semibold">
            {tr(data.support.role)}
            {engagingCard.subtitle}
          </h4> */}
          <ReactMarkdown components={{
            p: ({ ...props }) => <h4 {...props} className="text-[20px] [&_strong]:font-semibold" />,
            h1: ({ ...props }) => <h4 {...props} className="text-[20px] [&_strong]:font-semibold" />,
            h2: ({ ...props }) => <h4 {...props} className="text-[20px] [&_strong]:font-semibold" />,
            h3: ({ ...props }) => <h4 {...props} className="text-[20px] [&_strong]:font-semibold" />,
            h4: ({ ...props }) => <h4 {...props} className="text-[20px] [&_strong]:font-semibold" />,
          }}>
            {engagingCard.subtitle}
          </ReactMarkdown>
          {/* <p className="text-[16px] mb-6">
            {tr(data.support.text2)}
            {engagingCard.paragraph1}
          </p> */}
          <ReactMarkdown components={{
            p: ({ ...props }) => <p {...props} className="text-[16px] mb-6" />
          }}>
            {engagingCard.paragraph1}
          </ReactMarkdown>

          <ul className="mt-6">
            <li className="flex flex-row items-center gap-4 font-semibold">
              <X.Image src={CheckImage} alt="Check" className="w-[33px] h-[33px]" />
              <div className="flex-1 text-[14px]">
                {engagingCard.tagLine}
                {/* {tr(data.support.bullet)} */}
              </div>
            </li>
          </ul>

        </div>
      </div>
    </div>
  );
}


function SupportDesktop() {
  // const tr = X.useTranslator();
  const { ref, inView } = X.useInViewObserver<HTMLDivElement>();
  const engagingCard = useRetailerHomePage('engagingCard');
  return (
    <div ref={ref} className={X.clsx(
      X.desktopOnly("block"),
      "max-w-content mx-auto relative h-[540px]",
    )}>
      <div className={X.clsx(
        "bg-surface-blue p-10 rounded-4xl absolute left-0 top-0 right-[48%] pr-20",
        "transition-transform duration-500 transform-gpu",
        inView ? "translate-x-0" : "-translate-x-[100vw]",
      )}>
        <FreedomCard />
      </div>

      <div className={X.clsx(
        "absolute bg-white p-10 pb-20 pl-12 pr-0 rounded-4xl left-[48%] right-0 top-10",
        "transition-transform duration-500 transform-gpu",
        inView ? "translate-x-0" : "translate-x-[100vw]",
      )}>
        {/* <h3 className="text-[48px] mb-8 leading-tight [&_strong]:font-medium">{tr(data.support.title)}</h3> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <h3 {...props} className="text-[48px] mb-8 leading-tight [&_strong]:font-medium" />
        }}>
          {engagingCard.title}
        </ReactMarkdown>
        <div className="flex flex-row gap-6">
          <div>
            {/* <p className="text-[20px] mb-6">
              {engagingCard.paragraph1}
              {tr(data.support.text1)}
            </p> */}
            <ReactMarkdown components={{
              p: ({ ...props }) => <h3 {...props} className="text-[20px] mb-6" />
            }}>
              {engagingCard.paragraph1}
            </ReactMarkdown>
            {/* <h4 className="text-[26px] font-semibold">
              {tr(data.support.role)}
              {engagingCard.subtitle}
            </h4> */}
            <ReactMarkdown components={{
              p: ({ ...props }) => <h4 {...props} className="text-[26px]  [&_strong]:font-semibold" />,
              h1: ({ ...props }) => <h4 {...props} className="text-[26px] [&_strong]:font-semibold" />,
              h2: ({ ...props }) => <h4 {...props} className="text-[26px] [&_strong]:font-semibold" />,
              h3: ({ ...props }) => <h4 {...props} className="text-[26px] [&_strong]:font-semibold" />,
              h4: ({ ...props }) => <h4 {...props} className="text-[26px] [&_strong]:font-semibold" />,
            }}>
              {engagingCard.subtitle}
            </ReactMarkdown>
            {/* <p className="text-[20px] mb-6">
              {engagingCard.paragraph2}
              {tr(data.support.text2)}
            </p> */}
            <ReactMarkdown components={{
              p: ({ ...props }) => <h3 {...props} className="text-[20px] mb-6" />
            }}>
              {engagingCard.paragraph2}
            </ReactMarkdown>
          </div>
          <div className="w-[1400px]">
            {/* <X.Image
              alt="Support"
              className="w-full h-auto"
              src={SupportDesktopImage}
            /> */}
            <X.Image
              alt="Support"
              className="w-full h-auto rounded-2xl"
              src={engagingCard.image.url}
              width={engagingCard.image.width}
              height={engagingCard.image.height}
              unoptimized
            />
          </div>
        </div>
        <ul className="mt-6">
          <li className="flex flex-row items-center gap-4 font-semibold">
            <X.Image src={CheckImage} alt="Check" className="w-[40px] h-[40px]" />
            <div className="flex-1 text-[18px] font-semibold">
              {/* {tr(data.support.bullet)} */}
              <ReactMarkdown>
                {engagingCard.tagLine}
              </ReactMarkdown>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}


function FreedomCard() {
  // const tr = X.useTranslator();
  const advantage = useRetailerHomePage('advantagesCard');

  return (
    <>
      {/* <h3 className="text-[36px] max-w-[265px] xl:max-w-full xl:text-[48px] mb-4 xl:mb-8 leading-tight">
        {tr({
          en: <>Freedom and simplicity, <strong className="font-medium">no strings attached.</strong></>,
          fr: <>Liberté et simplicité, <strong className="font-medium">sans contrainte</strong></>,
        })}
      </h3> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h3 {...props} className="text-[36px] max-w-[265px] xl:max-w-full xl:text-[48px] mb-4 xl:mb-8 leading-tight" />,
        strong: ({ ...props }) => <strong {...props} className="font-medium" />
      }}>
        {advantage.title}
      </ReactMarkdown>
      {/* <p className="text-[16px] xl:text-[20px] leading-tight xl:leading-normal mb-6">
        {advantage.content}
        {tr({
          en: `Say goodbye to paperwork and complicated setups. With digital VAT refunds, there’s no integration, no forms, ans no accounting headaches.`,
          fr: `Dites adieu aux démarches fastidieuses ! Avec la détaxe digitale, plus besoin d’intégration complexe ni de paperasse.`,
        })}
      </p> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <p {...props} className="text-[16px] xl:text-[20px] leading-tight xl:leading-normal mb-6" />
      }}>
        {advantage.content}
      </ReactMarkdown>

      <ul className="flex flex-col gap-4 mb-8">
        {/* {[
          { en: `No tech implementation needed`, fr: `Aucune implémentation informatique requise` },
          { en: `No paper forms to manage`, fr: `Fini les bordereaux papier à gérer` },
          { en: `No tracking required - Zapptax refunds your customer directly`, fr: `Aucun suivi comptable : Zapptax rembourse directement votre client` },
        ] */}
        {
          // [
          //   { en: advantage.advantage1, fr: advantage.advantage1, zh: advantage.advantage1 },
          //   { en: advantage.advantage2, fr: advantage.advantage2, zh: advantage.advantage2 },
          //   { en: advantage.advantage3, fr: advantage.advantage3, zh: advantage.advantage3 },
          // ]
          [advantage.advantage1, advantage.advantage2, advantage.advantage3]
            .map((text, i) => (
              <li key={i} className="flex flex-row items-center gap-4 font-semibold">
                <X.Image src={CheckImage} alt="Check" className="w-[33px] h-[33px] xl:w-[40px] xl:h-[40px]" />
                <div className="flex-1 text-[14px] xl:text-[18px]">
                  {/* {tr(text)} */}
                  <ReactMarkdown>
                    {text}
                  </ReactMarkdown>
                </div>
              </li>
            ))}
      </ul>

      {/* <p className="text-[16px] xl:text-[20px] leading-tight xl:leading-normal mb-8">
        {advantage.message}
        {tr({
          en: `A smooth, stress-free solution — for both you and your customers.`,
          fr: `Un service fluide, sans stress, pour vous comme pour vos clients.`,
        })}
      </p> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <p {...props} className="text-[16px] xl:text-[20px] leading-tight xl:leading-normal mb-8" />
      }}>
        {advantage.message}
      </ReactMarkdown>

      <X.Button
        primary lg
        href="/retail/become-partner"
        label={advantage.cta}
      // label={tr({
      //   en: "Become a partner",
      //   fr: "Devenir partenaire",
      // })}
      />
    </>
  );
}


function BoostMobile() {
  // const tr = X.useTranslator();

  const promotionCard = useRetailerHomePage('promotionCard')
  return (
    <div className={X.clsx(
      X.mobileOnly(),
      "pl-mobile-margin pr-mobile-margin-half mr-mobile-margin-half bg-surface-green relative",
      "py-8"
    )}>
      <div>
        <X.Image src={PersonImage} alt="Happy Customer" className="absolute -top-[25px] -right-[120px] w-[300px] h-auto" />
        <X.Image src={GrowthImage} alt="Growth" className="absolute top-[220px] right-[160px] h-[70px] w-auto" />
        <X.Image src={CountriesImage} alt="Growth" className="absolute top-[300px] right-[110px] h-[36px] w-auto" />
      </div>

      {/* <h2 className="text-[36px] [&_strong]:font-medium leading-tight w-[50vw]">{tr(data.boost.title)}</h2> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h2 {...props} className="text-[36px] [&_strong]:font-medium leading-tight w-[50vw]" />
      }}>
        {promotionCard.title}
      </ReactMarkdown>
      <div className="mt-[180px] flex flex-col gap-4 mb-8">
        {/* TODO markdown */}
        {/* <p className="text-[16px]">{promotionCard.message}</p> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} className="text-[16px]" />
        }}>
          {promotionCard.message}
        </ReactMarkdown>
        {/* {data.boost.text.map((p, i) => (
          <p key={i} className="text-[16px]">{tr(p)}</p>
        ))} */}
      </div>

      <ul className="flex flex-col gap-4 mb-8">
        <li className="flex flex-row items-center gap-4 font-semibold text-[14px] leading-tight">
          <X.Image src={CheckImage} alt="Check" className="w-[33px] h-[33px]" />
          <div className="flex-1">
            <ReactMarkdown>
              {promotionCard.arg1}
            </ReactMarkdown>

          </div>
        </li>
        <li className="flex flex-row items-center gap-4 font-semibold text-[14px] leading-tight">
          <X.Image src={CheckImage} alt="Check" className="w-[33px] h-[33px]" />
          <div className="flex-1">
            <ReactMarkdown>
              {promotionCard.arg2}
            </ReactMarkdown>
          </div>
        </li>
        {/* {data.boost.bullets.map((bullet, i) => (
          <li key={i} className="flex flex-row items-center gap-4 font-semibold text-[14px] leading-tight">
            <X.Image src={CheckImage} alt="Check" className="w-[33px] h-[33px]" />
            <div className="flex-1">{tr(bullet)}</div>
          </li>
        ))} */}
      </ul>

      <div className="flex flex-col items-start">
        <X.Button
          primary lg
          href="/retail/become-partner"
          label={promotionCard.cta}
        // label={tr(data.boost.cta)}
        />
      </div>

    </div>
  );
}


function BoostDesktop() {
  const tr = X.useTranslator();
  const promotionCard = useRetailerHomePage('promotionCard')
  return (
    <div className={X.clsx(
      X.desktopOnly("flex"),
      "relative max-w-content mx-auto rounded-4xl mb-15 mt-55 bg-surface-green flex-row justify-end py-10 px-12",
    )}>
      <div>
        <X.Image src={PersonImage} alt="Happy Customer" className="absolute -top-[38px] left-[85px] w-[400px] h-auto" />
        <X.Image src={GrowthImage} alt="Growth" className="absolute top-[200px] left-[60px] h-[70px] w-auto" />
        <X.Image src={CountriesImage} alt="Growth" className="absolute bottom-[18px] left-[55px] h-[70px] w-auto" />
      </div>

      <div className="w-[60%] flex flex-col gap-4">
        {/* <h2 className="text-[48px] [&_strong]:font-medium leading-tight">{tr(data.boost.title)}</h2> */}
        <ReactMarkdown
          components={{
            p: ({ ...props }) => <h2 className="text-[48px] [&_strong]:font-medium leading-tight" {...props} />
          }}
        >
          {promotionCard.title}
        </ReactMarkdown>
        {/* {data.boost.text.map((p, i) => (
          <p key={i} className="text-[20px]">{tr(p)}</p>
        ))} */}
        {/* <p className="text-[20px]">{promotionCard.message}</p> */}
        <ReactMarkdown
          components={{
            p: ({ ...props }) => <p {...props} className="text-[20px]" />
          }}
        >
          {promotionCard.message}
        </ReactMarkdown>
        <ul className="w-[60%] flex flex-col gap-4">
          <li className="flex flex-row items-center gap-4 font-semibold text-[18px] leading-tight">
            <X.Image src={CheckImage} alt="Check" className="w-[40px] h-[40px]" />
            <div className="flex-1">
              <ReactMarkdown>
                {promotionCard.arg1}
              </ReactMarkdown>
            </div>
          </li>
          <li className="flex flex-row items-center gap-4 font-semibold text-[18px] leading-tight">
            <X.Image src={CheckImage} alt="Check" className="w-[40px] h-[40px]" />
            <div className="flex-1">
              <ReactMarkdown>
                {promotionCard.arg2}
              </ReactMarkdown>
            </div>
          </li>
          {/* {data.boost.bullets.map((bullet, i) => (
            <li key={i} className="flex flex-row items-center gap-4 font-semibold text-[18px] leading-tight">
              <X.Image src={CheckImage} alt="Check" className="w-[40px] h-[40px]" />
              <div className="flex-1">{tr(bullet)}</div>
            </li>
          ))} */}
        </ul>
        <div className="absolute right-12 bottom-10">
          <X.Button
            primary lg
            href="/retail/become-partner"
            // label={tr(data.boost.cta)}
            label={promotionCard.cta}
          />
        </div>
      </div>
    </div>
  );
}
